var FcSegmentsInputModule = /** @class */ (function () {
    function FcSegmentsInputModule() {
    }
    return FcSegmentsInputModule;
}());
export { FcSegmentsInputModule };
